var map = {
	"./add.svg": 91259,
	"./alipay.svg": 23612,
	"./alipay2.svg": 57766,
	"./alipayLogo.svg": 76193,
	"./americanExpressLogo.svg": 80885,
	"./articleSearch.svg": 65660,
	"./avatarDefault.svg": 4796,
	"./buy.svg": 80278,
	"./buyOA.svg": 3622,
	"./calendar.svg": 10460,
	"./cancel.svg": 88424,
	"./cancel2.svg": 90282,
	"./ccBy.svg": 59071,
	"./ccCc.svg": 88498,
	"./ccNc.svg": 69697,
	"./ccNd.svg": 9790,
	"./ccSa.svg": 40704,
	"./chat.svg": 29380,
	"./chevron.svg": 37135,
	"./clear.svg": 16673,
	"./clock.svg": 47828,
	"./connectAvator.svg": 74189,
	"./connectEmail.svg": 7424,
	"./connectLogo.svg": 46381,
	"./connectPrimary.svg": 24482,
	"./cover.svg": 71651,
	"./delete.svg": 43455,
	"./discoverLogo.svg": 5422,
	"./down.svg": 85326,
	"./download.svg": 93190,
	"./edit.svg": 38610,
	"./error.svg": 97852,
	"./eyeHide.svg": 15561,
	"./eyeShow.svg": 71146,
	"./hand.svg": 73677,
	"./help.svg": 88663,
	"./important.svg": 98080,
	"./info.svg": 15006,
	"./licenseCC.svg": 5025,
	"./licenseCTA.svg": 58883,
	"./loading.svg": 6282,
	"./mail.svg": 65779,
	"./masterCardLogo.svg": 27539,
	"./myAccountLink.svg": 31933,
	"./new.svg": 3012,
	"./next.svg": 76037,
	"./noteForAlipayIcon.svg": 22942,
	"./ok.svg": 18412,
	"./openAccess.svg": 86660,
	"./orcidLink.svg": 47375,
	"./orcidLogo.svg": 47218,
	"./orcidLogoIcon.svg": 56161,
	"./payOA.svg": 64120,
	"./pdf.svg": 9720,
	"./person.svg": 7637,
	"./previous.svg": 49853,
	"./schedule.svg": 20781,
	"./search.svg": 29998,
	"./share.svg": 24299,
	"./sign.svg": 41493,
	"./stepActive.svg": 81326,
	"./thunder.svg": 90992,
	"./up.svg": 20293,
	"./video.svg": 59243,
	"./visaLogo.svg": 62344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66922;